import React, { Component, useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { styled, useTheme } from '@mui/material/styles';
import {getChannel} from 'postal';
import { Icon, Paper, Typography } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import LinearProgress from '@mui/material/LinearProgress';
import SvgIcon from '@mui/material/SvgIcon';
import SearchIcon from '@mui/icons-material/Search';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import PreviewIcon from '@mui/icons-material/Preview';
import CloseIcon from '@mui/icons-material/Close';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import OutputIcon from '@mui/icons-material/Output';
import LockIcon from '@mui/icons-material/Lock';
import LockResetIcon from '@mui/icons-material/LockReset';
import InputIcon from '@mui/icons-material/Input';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { DateTime } from "luxon";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import AddBoxIcon from '@mui/icons-material/AddBox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';

import ReactPlayer from "react-player";
import { UserInfo, netGet, netPost, netDelete, netPostExt, netFetch, keycloak } from "../network";
import { default as FileUpload, netUpload} from '../file-upload';
import { EffectivityChooser } from "../effectivity/effectivity-chooser";
import debounce from 'lodash.debounce';
import { v4 as uuidv4 } from 'uuid';
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { Paginator } from 'primereact/paginator';
import SplitPane, { Pane } from 'split-pane-react-uxrd';
import 'split-pane-react-uxrd/esm/themes/default.css';
import { setMediaCategories, setCatalogReadOnly } from "../../features/media/catalogSlice";
import './catalog.css';
import { PictureViewer } from "./viewer";

const postal = getChannel('ucs');
var filteredImageCount = 0;
var globalSearchTerm = '';
var globalSearchUse = 'all';
var globalSelectedCategories = [];
var catalogSplitMode = false;
var ABORTED = false;
const DATE_FORMAT = 'dd MMM yyyy, HH:mm ZZZZ';
const SHELF_FORMAT = 'yyMMdd_HHmmss';


const stringHash = (str) => {
    if ( typeof str !== 'string') {
        return 0;
    }
    return str.split('').reduce((hash, char) => 
  (hash = char.charCodeAt(0) + (hash << 6) + (hash << 16) - hash), 0);
};

async function saveFile(blob, filename) {
    // create a new handle
    try {
        const newHandle = await window.showSaveFilePicker({ suggestedName: filename });

        // create a FileSystemWritableFileStream to write to
        const writableStream = await newHandle.createWritable();

        const readableStream = blob.stream();

        await readableStream.pipeTo(writableStream);
    } catch (error) {
        console.log('Save File error: ' + error);
    }
    /*
    // write our file
    await writableStream.write("This is my file content");
    */

    // close the file and write the contents to disk.
    // await writableStream.close();
}

// get file extension from content type (MIME type)
const getFileExtension = (t) => {
    if ( !(typeof t === 'string')) {
        return '';
    }
    if (t.includes('png')) {
        return '.png';
    }
    if (t.includes('jpeg')) {
        return '.jpg';
    }
    if (t.includes('pdf')) {
        return '.pdf';
    }
    if (t.includes('gif')) {
        return '.gif';
    }
    if (t.includes('svg')) {
        return '.svg';
    }
    if (t.includes('opus')) {
        return '.opus';
    }
    if (t.includes('video') && t.includes('webm')) {
        return '.webm';
    }
    if (t.includes('audio') && t.includes('webm')) {
        return '.weba';
    }
    if (t.includes('audio') && t.includes('mpeg')) {
        return '.mp3';
    }
    if (t.includes('audio') && t.includes('mp4')) {
        return '.m4a';
    }
    if (t.includes('wav')) {
        return '.wav';
    }
    if (t.includes('aac')) {
        return '.aac';
    }
    if (t.includes('video') && t.includes('mp4')) {
        return '.mp4';
    }
    if (t.includes('quicktime')) {
        return '.mov';
    }
    if (t.includes('x-msvideo')) {
        return '.avi';
    }
    if (t.includes('video') && t.includes('mpeg')) {
        return '.mpeg'; // or '.mpg'
    }
    if (t.includes('x-ms-wmv')) {
        return '.wmv';
    }
    if (t.includes('matroska')) {
        return '.mkv';
    }
    // console.log('No extension for ' + t);
    return '';
};

const isAudioOrVideoFile = (t) => {
    if ( !(typeof t === 'string')) {
        return false;
    }
    return t.includes('audio') || t.includes('video');
}

function MediaFileChooser(props) {
    const {
        open,
        onCancel,
        onSave,
        title = 'Choose Graphics',
        node,
        ...other
    } = props;

    const [sizes, setSizes] = useState([100, '25%', 'auto']);
    // const [url, setUrl] = useState('');
    const [categories, setCategories] = useState([]);
    const [images, setImages] = useState([]);
    const [filteredImages, setFilteredImages] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [categSelection, setCategSelection] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [selectedGlobalIndex, setSelectedGlobalIndex] = useState(-1);
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedImageName, setSelectedImageName] = useState('');
    const [selectedImageLabel, setSelectedImageLabel] = useState('');
    const theme = useTheme();

    useEffect(() => {
        if (open) {
            netGet('/api/catalog/categ')
                .then(response => response.json())
                .then(categs => {
                    if (Array.isArray(categs)) {
                        setCategories(categs.sort( (a,b) => a.name?.localeCompare(b.name)));
                        // console.log('Media categoeries: ' + JSON.stringify(categs));
                    }
                }).catch(error => console.log('Failed to retrieve categories: ' + error));
            const cs = [...categSelection];
            const cats = cs.map(id => {
                const i = id.indexOf('-');
                if (i >= 0 && i < id.length - 1) {
                    const c = id.substring(i + 1);
                    // console.log('cat=' + c);
                    return c;
                }
                return id;
            }).reduce((a, b) => a.length > 0 ? a + ',' + b : b, '');
            // const cat = cs.map(i => categories[i]).reduce((a, b) => a.length > 0 ? a + ',' + b.name : b.name, '');
            setSelectedIndex(-1);
            setSelectedImage(null);
            setSelectedImageLabel('');
            netGet('/api/catalog/image' + (cs.length > 0 ? '?cat=' + encodeURIComponent(cats) : ''))
                .then(response => response.json())
                .then(data => {
                    if (Array.isArray(data)) {
                        setImages(data);
                        const simage = loadNode();
                        if (simage[0] && simage[0] !== '') {
                            let imageIndex = data.findIndex(img => img.name === simage[0]);
                            if (imageIndex >= 0) {
                                // setImages(data);
                                const image = data[imageIndex];
                                setSelectedImage(image);
                                setSelectedImageLabel(image.label);
                                setSelectedIndex(imageIndex);
                            } else {
                                netGet('/api/catalog/image?name=' + encodeURIComponent(simage[0]))
                                    .then(response => response.json())
                                    .then(data2 => {
                                        if (Array.isArray(data2)) {
                                            // const images = [...data, ...data2];
                                            // setImages(images);
                                            imageIndex = data2.findIndex(img => img.name === simage[0]);
                                            if (imageIndex >= 0) {
                                                // console.log('images length=' + images.length + ' : ' + imageIndex);
                                                const image = data2[imageIndex];
                                                setSelectedImage(image);
                                                setSelectedImageLabel(image.label);
                                                // setSelectedIndex(imageIndex);
                                            }
                                        }
                                    }).catch(error => console.log('Failed to retrieve image info: ' + error));
                            }
                        } else {
                            setSelectedImage(null);
                            setSelectedImageName('');
                            setSelectedImageLabel('');
                        }
                        loadFilteredImages(searchTerm, data);
                    }
                }).catch(error => console.log('Failed to retrieve image info: ' + error));

            // setCategSelection([]);
        }

    }, [open, node]);

    /*
    useEffect( () => {
      if ( Array.isArray(node) ) {
        // console.log('Selected node: ' + JSON.stringify(node));
        const i = node.findIndex( t => t === 'fileref');
        if ( i >= 0 && i<node.length - 1) {
          const fr = node[i+1];
          if ( fr ) {
            const fre = fr.match(/\/(.*?)\/MAIN/);
            if ( Array.isArray(fre) && fre.length > 0 ) {
              let iname = fre[1];
              const j = iname.lastIndexOf('/');
              if ( j >= 0 && j < iname.length-1 ) {
                iname = iname.substring(j+1);
              }
              console.log('Selected image: ' + iname);
              setSelectedImageName(iname);
  
            }
          }
        }
      }
  
    },[node]);
    */

    const loadNode = () => {
        if (Array.isArray(node)) {
            // console.log('Selected node: ' + JSON.stringify(node));
            const i = node.findIndex(t => t === 'fileref');
            if (i >= 0 && i < node.length - 1) {
                const fr = node[i + 1];
                if (fr) {
                    const fre = fr.match(/\/(.*?)\/MAIN/);
                    if (Array.isArray(fre) && fre.length > 0) {
                        let iname = fre[1];
                        const j = iname.lastIndexOf('/');
                        if (j >= 0 && j < iname.length - 1) {
                            iname = iname.substring(j + 1);
                        }
                        // console.log('Selected image: ' + iname);
                        setSelectedImageName(iname);
                        return [iname, null];
                    }
                }
            }
        }
        return [null, null];
    };

    const loadFilteredImages = (term, timages) => {
        const lterm = typeof term === 'string' ? term.toLowerCase().trim() : '';
        let fimages = [...timages];
        // console.log('lterm: ' + lterm + ' : ' + fimages.length);
        if (lterm && lterm !== '') {
            fimages = timages.filter(img => {
                const lname = typeof img.name === 'string' ? img.name.toLowerCase() : '';
                const llabel = typeof img.label === 'string' ? img.label.toLowerCase() : '';
                return lname.includes(lterm) || llabel.includes(lterm);
            });
        }
        setFilteredImages(fimages);
    };

    const debouncedSearchTermChangeHandler = React.useCallback(
        debounce((value, timages) => {
            // Perform your action here with the debounced value
            // console.log('Debounced value:', value);
            loadFilteredImages(value, timages);
            setSearchTerm(value);
        }, 1500), // Debounce delay in milliseconds
        []
    );

    const searchTermChange = (event) => {
        // setSearchTerm(event.target.value);
        debouncedSearchTermChangeHandler(event.target.value, images);
    }

    const onClose = () => {
        onCancel();
    };

    const onCancelClick = () => {
        if (typeof onCancel === 'function') {
            onCancel();
        }
    };

    const onOKClick = () => {
        if (typeof onSave === 'function') {
            // onSave(url);
            // console.log('selectedImage: ' + JSON.stringify(selectedImage));
            const url = selectedImage ? selectedImage.path + '/MAIN' + getFileExtension(selectedImage?.type) : null;
            onSave(url, selectedImage);
        }
    };

    const categItemsChange = (event, itemIds) => {
        if (Array.isArray(itemIds)) {
            setCategSelection(itemIds);
            setSelectedImage(null);
            setSelectedIndex(-1);
            const cats = itemIds.map(id => {
                const i = id.indexOf('-');
                if (i >= 0 && i < id.length - 1) {
                    const c = id.substring(i + 1);
                    // console.log('cat=' + c);
                    return c;
                }
                return id;
            }).reduce((a, b) => a.length > 0 ? a + ',' + b : b, '');
            // console.log('itemIds=' + JSON.stringify(itemIds) + ', cat=' + cats);
            netGet('/api/catalog/image' + (itemIds.length > 0 ? '?cat=' + encodeURIComponent(cats) : ''))
                .then(response => response.json())
                .then(data => {
                    if (Array.isArray(data)) {
                        setImages(data);
                        if (selectedImageName && selectedImageName !== '') {
                            const imageIndex = data.findIndex(img => img.name === selectedImageName);
                            if (imageIndex >= 0) {
                                // setImages(data);
                                const image = data[imageIndex];
                                setSelectedImage(image);
                                setSelectedImageLabel(image.label);
                                setSelectedIndex(imageIndex);
                            }
                        }
                        loadFilteredImages(searchTerm, data);
                    }
                }).catch(error => console.log('Failed to retrieve image info: ' + error));
        }
    };

    const handleCategClick = (categ, index) => {
        const cs = [...categSelection];
        if (cs.includes(index)) {
            const j = cs.findIndex(item => item === index);
            if (j >= 0) {
                cs.splice(j, 1);
            }
        } else {
            cs.push(index);
        }
        setCategSelection(cs);
        setSelectedImage(null);
        setSelectedIndex(-1);
        const cat = cs.map(i => categories[i]).reduce((a, b) => a.length > 0 ? a + ',' + b.name : b.name, '');
        netGet('/api/catalog/image' + (cs.length > 0 ? '?cat=' + encodeURIComponent(cat) : ''))
            .then(response => response.json())
            .then(data => {
                if (Array.isArray(data)) {
                    setImages(data);
                    if (selectedImageName && selectedImageName !== '') {
                        const imageIndex = data.findIndex(img => img.name === selectedImageName);
                        if (imageIndex >= 0) {
                            // setImages(data);
                            const image = data[imageIndex];
                            setSelectedImage(image);
                            setSelectedImageLabel(image.label);
                            setSelectedIndex(imageIndex);
                        }
                    }
                }
            }).catch(error => console.log('Failed to retrieve image info: ' + error));
    };

    const handleImageClick = (image, index) => {
        setSelectedImage(image);
        setSelectedIndex(index);
        setSelectedImageName(image.name);
        setSelectedImageLabel(image.label);
        // console.log('Selected Image: ' + JSON.stringify(image));
    };

    const getImageExtension = (image) => {
        const t = image.type;
        if (t.includes('png')) {
            return '.png';
        }
        if (t.includes('jpeg')) {
            return '.jpg';
        }
        if (t.includes('pdf')) {
            return '.pdf';
        }
        if (t.includes('gif')) {
            return '.gif';
        }
        if (t.includes('svg')) {
            return '.svg';
        }
        if (t.includes('opus')) {
            return '.opus';
        }
        if (t.includes('video') && t.includes('webm')) {
            return '.webm';
        }
        if (t.includes('audio') && t.includes('webm')) {
            return '.weba';
        }
        if (t.includes('audio') && t.includes('mpeg')) {
            return '.mp3';
        }
        if (t.includes('audio') && t.includes('mp4')) {
            return '.m4a';
        }
        if (t.includes('wav')) {
            return '.wav';
        }
        if (t.includes('aac')) {
            return '.aac';
        }
        if (t.includes('video') && t.includes('mp4')) {
            return '.mp4';
        }
        if (t.includes('quicktime')) {
            return '.mov';
        }
        if (t.includes('x-msvideo')) {
            return '.avi';
        }
        if (t.includes('video') && t.includes('mpeg')) {
            return '.mpeg'; // or '.mpg'
        }
        if (t.includes('x-ms-wmv')) {
            return '.wmv';
        }
        if (t.includes('matroska')) {
            return '.mkv';
        }
        console.log('No extension for ' + t);
        return '';
    }

    const getImageUrl = (image) => {
        // thumbnail is always PNG
        const url = new URL('/api/fs' + image.path + '/THUMB.png', window.location.href);
        return url.toString();
    }
    const itemTemplate = (item, layout, index) => {
        const selected = item.name === selectedImageName;
        return (
            <Tooltip title={
                <Box>
                    <Typography sx={{ fontWeight: 'bold' }}>{item.name}</Typography>
                    <Typography>{item.label}</Typography>
                </Box>
            }>
                <Box sx={{ width: '104px', padding: 0, margin: 0 }}>
                    <IconButton onClick={() => handleImageClick(item, index)}
                        sx={{
                            border: selected ? '3px solid red' : '3px solid transparent', borderRadius: 0,
                            backgroundColor: selected ? 'gray' : 'white',
                            padding: 0,
                            margin: 0,
                        }} >
                        <img
                            style={{ height: '92px', width: '92px', maxHeight: '92px', maxWidth: '92px', opacity: selected ? 0.6 : 1 }}
                            src={getImageUrl(item)}
                            alt={item.label}
                            loading="lazy"
                        />
                    </IconButton>
                    <Typography sx={{ fontSize: '8pt', overflow: 'clip', padding: '4px', textWrap: 'nowrap', textOverflow: 'ellipsis' }}>{item.label}</Typography>
                </Box>
            </Tooltip>
        );
    };

    const listTemplate = (items, layout) => {
        return <Box sx={{
            display: 'flex', flexWrap: 'wrap', alignItems: 'center',
            rowGap: '15px', columnGap: '5px', height: '610px', alignContent: 'flex-start'
        }}>{items.map((item, index) => itemTemplate(item, layout, index))}</Box>;
    };



    return (
        <Dialog
            maxWidth={'1200px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 1000,
                        minHeight: 860,
                        maxHeight: 1200
                    }
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
            <DialogContent >

                <Box sx={{ width: '100%', height: '100%', position: 'relative' }}>
                    <SplitPane
                        style={{ minHeight: '3.3em' }}
                        split="vertical"
                        sizes={sizes}
                    >
                        <Pane minSize={40} maxSize='60%'>
                            <Box sx={{ paddingLeft: 0, paddingTop: 1 }}>
                                <Typography sx={{ fontWeight: 'bold' }}>Category</Typography>
                            </Box>
                        </Pane>
                        <Box sx={{ width: '100%', textAlign: 'center' }} >
                            <TextField
                                defaultValue={searchTerm}
                                onChange={searchTermChange}
                                id="xxe-search"
                                size="small"
                                type="search"
                                fullWidth
                                sx={{ maxWidth: '500px' }}
                                slotProps={{
                                    input: {
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                    }
                                }}
                            />
                        </Box>
                    </SplitPane>
                    <SplitPane
                        style={{ minHeight: '680px', height: '100%' }}
                        split='vertical'
                        sizes={sizes}
                        onChange={setSizes}
                    >
                        <Pane minSize={40} maxSize='60%'>
                            <Box sx={{ height: '100%', position: 'relative', overflow: 'auto' }}>

                                <SimpleTreeView multiSelect selectedItems={categSelection} onSelectedItemsChange={categItemsChange}>
                                    {Array.isArray(categories) && categories.map((categ, index) =>
                                        <TreeItem itemId={`C${index}-${categ.name}`} label={categ.name} />
                                    )}
                                </SimpleTreeView>
                            </Box>
                        </Pane>
                        <Box sx={{
                            height: '100%', position: 'relative', overflow: 'auto', paddingLeft: 1,
                            borderLeftColor: theme.palette.divider, borderLeftStyle: 'solid', borderLeftWidth: '2px'
                        }} >

                            <DataView value={filteredImages} listTemplate={listTemplate} layout="grid" paginator rows={24} />
                        </Box>
                    </SplitPane>
                </Box>
            </DialogContent>
            <DialogActions sx={{ m: 1, display: 'flex', justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex' }}>
                    <Box>
                        <Box sx={{ paddingLeft: 2, width: '8em', fontWeight: 'bold' }}>Selected:</Box>
                        <Box sx={{ width: '8em' }}>{'\xa0'}</Box>
                    </Box>
                    <Box>
                        <Box>{selectedImage && selectedImage.name ? selectedImage.name : selectedImageName}</Box>
                        <Box>{selectedImage && selectedImage.label ? selectedImage.label : selectedImageLabel}</Box>
                    </Box>

                </Box>
                <Box sx={{ display: 'inline' }}>
                    <Button variant="outlined" onClick={onOKClick} sx={{ minWidth: '7em' }} color="success">OK</Button>
                    <Button variant="outlined" onClick={onCancelClick} sx={{ marginLeft: 2, minWidth: '7em' }}>Cancel</Button>
                </Box>
            </DialogActions>
        </Dialog>

    );


}

function AddCategoryDialog(props) {
    const {
        title = 'Add Category',
        type,
        open,
        onSave,
        onCancel,
        ...other
    } = props;

    // const [content, setContent] = useState('');
    const [okEnabled, setOkEnabled] = useState(false);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    
    useEffect(() => {
        // setContent('');
        if ( open ) {
            setOkEnabled(false);
            setName('');
            setDescription('');
        }
    }, [open]);

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if (reason === 'backdropClick') {
            return;
        }
        if (typeof onCancel === 'function') {
            onCancel();
        }
    };


    const onOKClick = () => {
        if (typeof onSave === 'function') {
            onSave({
                name: name,
                description: description,
            });
        }
    }


    const handleNameChange = (event) => {
        setOkEnabled(true);
        setName(event.target.value);
    };

    const handleDescriptionChange = (event) => {
        setDescription(event.target.value);
    }

    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 600,
                        maxWidth: 600,
                        maxHeight: 550,
                        minHeight: 400,
                    }
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
            <DialogContent>
                <TextField label="Name" value={name} onChange={handleNameChange} fullWidth size="small" sx={{marginTop: 2}} />
                <TextField label="Description" value={description} onChange={handleDescriptionChange} fullWidth size="small" sx={{marginTop: 2}} 
                    multiline rows="3" />
            </DialogContent>
            <DialogActions sx={{ padding: 3, paddingTop: 1}}>
                <Button variant="outlined" onClick={() => onOKClick()} sx={{ minWidth: '7em' }} disabled={!okEnabled} >Add</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', marginLeft: 2 }}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}

function DeleteCategoryDialog(props) {
    const {
        title = 'Delete Category',
        index,
        categ,
        open,
        onSave,
        onCancel,
        ...other
    } = props;

    const [okEnabled, setOkEnabled] = useState(true);

    useEffect(() => {
    }, [open]);

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if (reason === 'backdropClick') {
            return;
        }
        if (typeof onCancel === 'function') {
            onCancel();
        }
    };

    const onOKClick = () => {
        if (typeof onSave === 'function') {
            onSave({
                categ: categ,
                index: index,
            });
        }
    }

    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 600,
                        maxWidth: 600,
                        maxHeight: 450,
                        minHeight: 350,
                    }
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
            <DialogContent sx={{ overflowY: 'auto'}}>
                <Typography sx={{pl: 2, pt: 2}} variant="h6">{categ?.name}</Typography>
                <Typography sx={{pl: 2, pt: 1}}>{categ?.description}</Typography>
            </DialogContent>
            <DialogActions sx={{ padding: 3, paddingTop: 1}}>
                <Button variant="outlined" onClick={() => onOKClick()} sx={{ minWidth: '7em' }} disabled={!okEnabled} color="error" >Delete</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', marginLeft: 2 }}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}

function DeleteImageDialog(props) {
    const {
        title = 'Delete Image',
        index,
        image,
        open,
        onSave,
        onCancel,
        ...other
    } = props;

    const [okEnabled, setOkEnabled] = useState(true);

    useEffect(() => {
    }, [open]);

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if (reason === 'backdropClick') {
            return;
        }
        if (typeof onCancel === 'function') {
            onCancel();
        }
    };

    const onOKClick = () => {
        if (typeof onSave === 'function') {
            onSave({
                image: image,
                index: index,
            });
        }
    }

    const getImageExtension = (img) => {
        if (img?.type) {
            const t = img.type;
            if (t.includes('png')) {
                return '.png';
            }
            if (t.includes('jpeg')) {
                return '.jpg';
            }
            if (t.includes('pdf')) {
                return '.pdf';
            }
            if (t.includes('gif')) {
                return '.gif';
            }
            if (t.includes('svg')) {
                return '.svg';
            }
        }
        return '';
    }

    const getThumbUrl = (img) => {
        const url = new URL('/api/fs' + img?.path + '/THUMB.png', window.location.href);
        return url.toString();
    };

    const getImageUrl = (img) => {
        const url = new URL('/api/fs' + img?.path + '/MAIN' + getFileExtension(img?.type), window.location.href);
        return url.toString();
    }

    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 600,
                        maxWidth: 600,
                        maxHeight: 550,
                        minHeight: 350,
                    }
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
            <DialogContent sx={{ overflowY: 'auto'}}>
                <Typography sx={{pl: 2, pt: 2}} variant="h6">{image?.label}</Typography>
                <Typography sx={{pl: 2, pt: 1}}>{image?.description}</Typography>
                <Box sx={{ width: '104px', padding: 0, margin: 0, paddingTop: 2, pl: 2 }}>
                    <img
                        style={{ height: '128px', maxHeight: '127px', maxWidth: '500px' }}
                        src={isAudioOrVideoFile(image?.type) ? getThumbUrl(image) : getImageUrl(image)}
                        alt={image?.label}
                        loading="lazy"
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ padding: 3, paddingTop: 1}}>
                <Button variant="outlined" onClick={() => onOKClick()} sx={{ minWidth: '7em' }} disabled={!okEnabled} color="error" >Delete</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', marginLeft: 2 }}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}

function RevokeImageDialog(props) {
    const {
        title = 'Revoke Image Checkout',
        index,
        image,
        open,
        onSave,
        onCancel,
        ...other
    } = props;

    const [okEnabled, setOkEnabled] = useState(true);

    useEffect(() => {
    }, [open]);

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if (reason === 'backdropClick') {
            return;
        }
        if (typeof onCancel === 'function') {
            onCancel();
        }
    };

    const onOKClick = () => {
        if (typeof onSave === 'function') {
            onSave({
                image: image,
                index: index,
            });
        }
    }

    const getThumbUrl = (img) => {
        const url = new URL('/api/fs' + img?.path + '/THUMB.png', window.location.href);
        return url.toString();
    };

    const getImageUrl = (img) => {
        const url = new URL('/api/fs' + img?.path + '/MAIN' + getFileExtension(img?.type), window.location.href);
        return url.toString();
    }

    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 600,
                        maxWidth: 600,
                        maxHeight: 550,
                        minHeight: 350,
                    }
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
            <DialogContent sx={{ overflowY: 'auto'}}>
                <Typography sx={{pl: 2, pt: 2}} variant="h6">{image?.label}</Typography>
                <Typography sx={{pl: 2, pt: 1, fontStyle: 'italic'}}>{image?.description}</Typography>
                <Box sx={{ width: '104px', padding: 0, margin: 0, paddingTop: 2, pl: 2 }}>
                    <img
                        style={{ height: '128px', maxHeight: '127px', maxWidth: '500px' }}
                        src={isAudioOrVideoFile(image?.type) ? getThumbUrl(image) : getImageUrl(image)}
                        alt={image?.label}
                        loading="lazy"
                    />
                </Box>
                <Typography sx={{pl: 2, pt: 2}}>Image file lock will be released and file state reverted.</Typography>
                <Typography sx={{pl: 2, pt: 0, pb: 4}}>Please delete the file that was stored in the local file system.</Typography>
            </DialogContent>
            <DialogActions sx={{ padding: 3, paddingTop: 1}}>
                <Button variant="outlined" onClick={() => onOKClick()} sx={{ minWidth: '7em' }} disabled={!okEnabled} color="warning" >Revoke</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', marginLeft: 2 }}>Cancel</Button>
            </DialogActions>
        </Dialog>

    );

}

function ErrorDialog(props) {
    const {
        title,
        message,
        open,
        onClose,
        ...other
    } = props;

    const onOKClick = () => {
        if ( typeof onClose === 'function' ) {
            onClose();
        }
    };

    const onLocalClose = () => {
        if ( typeof onClose === 'function' ) {
            onClose();
        }
    };

    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onLocalClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 500,
                        maxHeight: 600
                    }
                }
            }}
        >
            <DialogTitle sx={{fontWeight: 'bold', backgroundColor: '#d32f2f'}}>{title}</DialogTitle>
            <DialogContent>
                
                <Box sx={{paddingTop: '2ex'}}>
                    <Typography>
                        {message}
                    </Typography>
                </Box>
                
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onOKClick} sx={{minWidth: '7em'}} >Close</Button>
            </DialogActions>
        </Dialog>

    );

}

function ImportImageDialog(props) {
    const {
        title = 'Import Images',
        open,
        onCancel,
        onSave,
        image,
        categs,
        checkin=false,
        // targetFiles,
        description,
        shelf,
        okLabel='Import',
        acceptFiles={ 'image/png': ['.png'], 'image/jpeg': ['.jpg', '.jpeg' ], 
            'image/gif': ['.gif'], 'image/svg+xml': ['.svg'], 'image/tiff': ['.tif', '.tiff'],
            'application/pdf': ['.pdf'], 
            'audio/opus': ['.opus'], 'audio/mpeg': ['.mp3'], 'audio/wav': ['.wav'],
            'audio/aac': ['.aac'], 'audio/mp4': ['.m4a'], 'audio/ogg': ['.ogg', '.oga'],
            'audio/x-ms-wma': ['.wma'], 'audio/midi': ['.mid', '.midi'],
            'audio/flac': ['.flac'], 'audio/webm': ['.weba'],
            'video/mp4': ['.mp4', '.m4v'], 'video/webm': ['.webm'],
            'video/ogg': ['.ogv'], 'video/quicktime': ['.qt', '.mov'],
            'video/x-msvideo': ['.avi'], 'video/mpeg': ['.mpg', '.mpeg'],
            'video/x-ms-wmv': ['.wmv'], 'video/x-matroska': ['.mkv'],
            'video/x-flv': ['.flv']
        },
        acceptLabel="Drag and drop image files here, or click to select files",
        ...other
    } = props;

    const [selected, setSelected] = React.useState([]);
    const [target, setTarget] = React.useState([]);
    const [selectedTarget, setSelectedTarget] = React.useState([]);
    const [changed, setChanged] = useState(false);
    const [files, setFiles] = React.useState([]);
    const [desc, setDesc] = React.useState('');
    const [shelfId, setShelfId] = React.useState(DateTime.now().toFormat(SHELF_FORMAT));
    const [progressValue, setProgressValue] = React.useState([]);
    const [progressFactor, setProgressFactor] = React.useState(1);
    const [progressShow, setProgressShow] = React.useState(false);
    const [aborted, setAborted] = React.useState(false);
    const fileUploadProgress = useSelector((state) => state.fileUpload.progress);
    const [errorOpen, setErrorOpen] = React.useState(false);
    const [errorTitle, setErrorTitle] = React.useState('Upload Error');
    const [errorMessage, setErrorMessage] = React.useState('An error occurred uploading files. Please try again or consult administrator if problem persists.');
    const [categories, setCategories] = useState([]);
    const [categoryNames, setCategoryNames] = useState([]);
    const [selectedCateg, setSelectedCateg] = useState([]);

    const theme = useTheme();

    const ABORTED_MESSAGE = 'Aborted';
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        slotProps: {
            paper: {
                style: {
                    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                    width: 250,
                },
            },
        },
    };

    React.useEffect(() => {
        setFiles([]);
        setErrorOpen(false);
        setTarget([]);
        /*
        if ( Array.isArray(targetFiles) ) {
            setTarget(targetFiles);
        } else if ( open ) {
            setTarget([]);
        }
        */
        if ( description ) {
            setDesc(description);
        } else {
            setDesc('');
        }
        if ( open ) {
            setChanged(false);
            setAborted(false);
            ABORTED=false;
            loadCategories();
            if ( checkin && image ) {
                setDesc(image.description);
            }
            if ( Array.isArray(categs) ) {
                setSelectedCateg(categs);
            }
        }
        if ( shelf && shelf !== '') {
            setShelfId(shelf);
        } else {
            setShelfId(DateTime.now().toFormat(SHELF_FORMAT));
        }
    }, [open, shelf, description, image, categs]);

    React.useEffect( ()=> {
        setProgressValue(fileUploadProgress / progressFactor);
    }, [fileUploadProgress, progressFactor]);

    
    const loadCategories = (callback) => {
        netGet('/api/catalog/categ')
            .then(response => response.json())
            .then(categs => {
                if (Array.isArray(categs)) {
                    const sorted = categs.sort( (a,b) => a.name ? (a.name.localeCompare(b?.name)) : 1);
                    setCategories(sorted);
                    setCategoryNames(sorted.map(c => c.name));
                    if ( typeof callback === 'function') {
                        callback(sorted);
                    }
                    // console.log('Media categoeries: ' + JSON.stringify(categs));
                }
            }).catch(error => console.log('Failed to retrieve categories: ' + error));
    };

    const uploadFiles = () => {
        const allFiles = [];
        const localFiles = [];
        

        target.forEach( item => {
            if ( item.origin === 'F' && !item.uploaded ) {
                localFiles.push(item);
                // netUpload(item.file, `/api/upload/${item.uid}?dst=${item.path}&uid=${item.uid}`);
            } else {
                allFiles.push(item);
            }

        });
        console.log('Local files: ' + localFiles.length);
        setAborted(false);
        
        setProgressShow(true);
        if ( localFiles.length > 0 ) {
            setProgressFactor(localFiles.length);
        } else {
            setProgressFactor(1);
        }
        setProgressValue(0);
        localFiles.reduce(function (prev, item) {
            return prev.then((value) => {
                if ( ABORTED ) {
                    console.log('Aborting ...');
                    return Promise.reject(ABORTED_MESSAGE);
                } else if (value.status >= 400) {
                    return Promise.reject(value.statusText);
                } else {
                    if (value.token) {
                        // console.log('value token1: ' + JSON.stringify(value.token));
                        const dest = {
                            path: value.token.path,
                            label: value.token.label,
                            uid: value.token.uid,
                            origin: 'F',
                            image: image,
                        };
                        allFiles.push(dest);
                        // console.log('Adding ' + JSON.stringify(dest));
                    }
                    return netUpload(item.file, `/api/upload/${item.uid}?dst=${item.path}&uid=${item.uid}`, item);
                }
            });
        }, Promise.resolve({})).then((value) => {
            if ( ABORTED ) {
                console.log('Aborting ...');
                return Promise.reject(ABORTED_MESSAGE);
            } else if (value.status >= 400) {
                return Promise.reject(value.statusText);
            } else if (value.token) {
                // console.log('value token2: ' + JSON.stringify(value.token));
                const dest = {
                    path: value.token.path,
                    label: value.token.label,
                    uid: value.token.uid,
                    origin: 'F',
                    uploaded: true,
                    description: desc,
                    image: image,
                };
                allFiles.push(dest);
                setProgressShow(false);
                // console.log('Adding ' + JSON.stringify(dest));

                setTarget(allFiles);
                if (typeof onSave === 'function') {
                    // console.log('Saving ' + JSON.stringify(allFiles));
                    // onSave(allFiles, desc, shelfId);
                    onSave({
                        files: allFiles,
                        description: desc,
                        shelfId: shelfId,
                        categories: selectedCateg,
                        image: image,
                    });
                }
            }

        }).catch(error => {
            console.log('Error uploading files. Please try again or consult administrator if problem persists: ' + error);
            setProgressShow(false);
            setErrorOpen(true);
        }); 
        console.log('Uploading files and showing progress now...');
    };

    const onErrorClose = () => {
        setErrorOpen(false);
    };


    const onOkClick = () => {
        ABORTED = false;
        const localFiles = target.filter( item => item.origin === 'F'  && !item.uploaded );
        if ( localFiles.length > 0 ) {
            uploadFiles();
            // setTimeout(uploadFiles, 4000);
        } else {
            if (typeof onSave === 'function') {
                onSave({
                    files: target, 
                    description: desc, 
                    shelfId: shelfId,
                    categories: selectedCateg,
                    image: image,
                });
            }
        }
    };

    const onCancelClick = () => {
        setAborted(true);
        ABORTED = true;
        console.log('ABORTING...');
        onClose();
    };

    const onClose = () => {
        if (typeof onCancel === 'function') {
            onCancel();
        }
    };

    const handleFileChange = (newFile) => {
        // setFiles(newFile);
        const rawFiles = [...files];
        newFile.forEach( f => {
            const oldf = rawFiles.find( rf => rf.name === f.name);
            if ( !oldf ) {
                rawFiles.push(f);
            } else {
                console.log(f.name + ' already added.');
            }
        });
        const fs = [];
        const upid = shelfId;
        console.log('shelfId: ' + upid);
        rawFiles.forEach((f) => {
            fs.push({
                origin: 'F',
                path: `/opt/UCS/dlib/uploads/${upid}/${f.name}`,
                label: f.name,
                file: f,
                uid: upid,
            })
        });
        setFiles(rawFiles);
        setSelected(fs);
        setTarget(fs);
        setChanged(true);
        console.log('File changed: ' + newFile);
    };

    const handleFileRemove = (newFiles) => {
        setFiles(newFiles);
        const fs = [];
        const upid = shelfId;
        console.log('shelfId: ' + upid);
        newFiles.forEach((f) => {
            fs.push({
                origin: 'F',
                path: `/opt/UCS/dlib/uploads/${upid}/${f.name}`,
                label: f.name,
                file: f,
                uid: upid,
            })
        });
        setSelected(fs);
        setTarget(fs);
        setChanged(true);
    }

    const handleDescriptionChange = (event) => {
        setDesc(event.target.value);
        setChanged(true);
    }

    const handleCategChange = (value) => {
        /*
        const {
            target: { value },
        } = event;
        */
        setSelectedCateg(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
        setChanged(true);
    };

    const getStyles = (name, categs, theme) => {
        return {
            fontWeight: categs.includes(name)
                ? theme.typography.fontWeightMedium
                : theme.typography.fontWeightRegular,
        };
    };

    const getDisabled = () => {
        if ( checkin ) {
            return !(changed || (Array.isArray(target) && target.length > 0));
        } else {
            return !Array.isArray(target) || target.length === 0;
        }
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        [theme.breakpoints.up('lg')]: {
                            width: 1000,
                            minWidth: 1000,
                            minHeight: 800
                        },
                        [theme.breakpoints.down('lg')]: {
                            width: '100%',
                            minWidth: '100%',
                            minHeight: '90%'
                        },
                    }
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
            <DialogContent sx={{height: '100%', display: 'grid', gridTemplateRows: '1fr min-content',  position: 'relative', padding: 3}}>
                <Box sx={{  width: '100%', display: 'flex', alignContent: 'stretch', justifyContent: 'center', alignItems: 'stretch', position: 'relative', overflow: 'auto', 
                        
                 }}>
                    <FileUpload buttonText='Select' title={acceptLabel} accept={acceptFiles}
                        value={files} onChange={handleFileChange} onRemove={handleFileRemove} sx={{ width: '100%' }} multiple={!checkin} maxFiles={checkin ? 1 : 100} />
                </Box>
                {!checkin &&
                    <Box sx={{ width: '100%', padding: 3, paddingLeft: 0, paddingRight: 0 }}>
                        <TextField value={desc} onChange={handleDescriptionChange} label="Description" placeholder="Input optional description" size="small" sx={{ width: '100%' }}
                            slotProps={{ inputLabel: { shrink: true } }} />

                        <MultipleSelectionEditor headerLabel="Categories" addActionLabel="Add Category" deleteActionLabel="Delete Category" 
                            values={selectedCateg} options={categoryNames} onChange={handleCategChange} />

                        {/* 
                        <FormControl sx={{ mt: 3, width: '100%' }}>
                            <InputLabel id="categ-multiple-name-label">Categories</InputLabel>
                            <Select
                                labelId="categ-multiple-name-label"
                                id="categ-multiple-name"
                                multiple
                                value={selectedCateg}
                                onChange={handleCategChange}
                                input={<OutlinedInput label="Categories" />}
                                MenuProps={MenuProps}
                            >
                                {categories.map((categ) => (
                                    <MenuItem
                                        key={categ.name}
                                        value={categ.name}
                                        style={getStyles(categ.name, selectedCateg, theme)}
                                    >
                                        {categ.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        */}
                    </Box>
                    
                }
            </DialogContent>
            <DialogActions sx={{padding: 3, justifyContent: 'space-between'}}>
                <Box sx={{visibility: progressShow ? 'visible' : 'hidden', minWidth: '500px'}}>
                    <LinearProgress variant="determinate" value={progressValue} />
                </Box>
                <Box>
                    <Button variant="outlined" onClick={onOkClick} sx={{ minWidth: '7em' }} disabled={getDisabled()}>{okLabel}</Button>
                    <Button variant="outlined" onClick={onCancelClick} sx={{ marginLeft: '1em', minWidth: '7em' }}>Cancel</Button>
                </Box>
                <ErrorDialog open={errorOpen} title={errorTitle} message={errorMessage} onClose={onErrorClose} />
            </DialogActions>
        </Dialog>

    );

}

function ImageViewer(props) {
    const {
        img,
        ...other
    } = props;

    const [splitSizes, setSplitSizes] = useState(['30%', 'auto']);
    const [imageViewerSizeChange, setImageViewerSizeChange] = useState(0);
    const [imageInfo, setImageInfo] = useState(null);
    const [allCategories, setAllCategories] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedCateg, setSelectedCateg] = useState(-1);
    const [effectivity, setEffectivity] = useState([]);
    const [selectedEff, setSelectedEff] = useState(-1);
    const [facet, setFacet] = useState(null); // the main facet
    const [dimensions, setDimensions] = useState('');
    const [checkinDialogOpen, setCheckinDialogOpen] = useState(false);
    const [serial, setSerial] = useState(0);
    const [propertiesDialogOpen, setPropertiesDialogOpen] = useState(false);
    const readOnly = useSelector( (state) => state.catalog.readOnly);

    useEffect(() => {
        loadCategories();
    },[]);

    useEffect(() => {
        if ( img ) {
            console.log('Image: ' + JSON.stringify(img));
            loadImage();
        }
    },[img, serial]);

    const loadImage = (sendEvent=false) => {
        netGet(`/api/catalog/image/info/${img.name}`)
            .then(response => response.json())
            .then(info => {
                console.log('Image info: ' + JSON.stringify(info));
                if (info) {
                    setImageInfo(info);
                }
                if (Array.isArray(info?.categories)) {
                    setCategories(info.categories);
                }
                if ( Array.isArray(info?.effectivity ) ) {
                    setEffectivity(info.effectivity);
                }
                if (info?.facet) {
                    setFacet(info.facet);
                    if ( info.facet.width > 0 ) {
                        setDimensions(`${info.facet.width}x${info.facet.height}`);
                    } else {
                        setDimensions('');
                    }
                } else {
                    setFacet(null);
                    setDimensions('');
                }
                if ( sendEvent ) {
                    postal.publish(
                        'app.catalog.image.change',
                        info.info,
                    )
                }
            });
    };

    const loadCategories = (callback) => {
        netGet('/api/catalog/categ')
            .then(response => response.json())
            .then(categs => {
                if (Array.isArray(categs)) {
                    const sorted = categs.sort( (a,b) => a.name ? (a.name.localeCompare(b?.name)) : 1);
                    setAllCategories(sorted);
                    if ( typeof callback === 'function') {
                        callback(sorted);
                    }
                    // console.log('Media categoeries: ' + JSON.stringify(categs));
                }
            }).catch(error => console.log('Failed to retrieve categories: ' + error));
    };

    const getImageExtension = (image) => {
        const t = image.type;
        if (t.includes('png')) {
            return '.png';
        }
        if (t.includes('jpeg')) {
            return '.jpg';
        }
        if (t.includes('pdf')) {
            return '.pdf';
        }
        if (t.includes('gif')) {
            return '.gif';
        }
        if (t.includes('svg')) {
            return '.svg';
        }
        if ( t.includes('opus') ) {
            return '.opus';
        }
        if ( t.includes('wav') ) {
            return '.wav';
        }
    }

    const getFacetExtension = (facet) => {
        const p = facet?.path;
        if ( p ) {
            const i = facet.path.lastIndexOf('.');
            return facet.path.substring(i);
        }
        return '';
    }

    const getImagePath = (image) => {
        if ( facet?.path ) {
            return facet.path;
        }
        return 'MAIN' + getFileExtension(image?.type);
    }



    

    const getThumbUrl = (image) => {
        // thumbnail is always PNG
        const url = new URL('/api/fs' + image.path + '/THUMB.png', window.location.href);
        return url.toString();
    }

    const getImageUrl = (image) => {
        const url = new URL('/api/fs' + image.path + '/' + getImagePath(image), window.location.href);
        return url.toString();
    }

    const handlePanelClose = () => {
        MediaCatalogModule.setCard({
            cmd: 'CLOSE_WINDOW',
            name: 'image',
            reuse: false,
            right: true,
            label: 'Image Viewer',
            origin: 'graphics',
            icon: <PreviewIcon fontSize="inherit" />
        });
    };

    const handleCategSelect = (categ, index, event) => {
        setSelectedCateg(index);
    };

    const handleEffSelect = (eff, index, event) => {
        setSelectedEff(index);
    };

    const handleExportImage = () => {
        const iurl = getImageUrl(img);
        console.log('Downloading ' + iurl);
        const link = document.createElement('a');
        link.href = iurl;
        link.download = img.label + getImageExtension(img);
        link.click();
        /*
        netGet(iurl)
            .then(response => {
                const blob = new Blob(response.data, { type: img.type});
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = img.label + getImageExtension(img);
                link.click();
                URL.revokeObjectURL(url);
            });
        */
        /*
        const data = 'This is the file content'
        const blob = new Blob([data], { type: 'text/plain' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'example.txt'
        link.click()
        URL.revokeObjectURL(url)
        */
    };

    const handleCheckoutImage = () => {
        netGet(`/api/catalog/image/checkout/${img.name}`)
            .then(response => {
                if ( response.ok ) {
                    const iurl = getImageUrl(img);
                    console.log('Downloading checkout ' + iurl);
                    const link = document.createElement('a');
                    link.href = iurl;
                    link.download = img.label + getImageExtension(img);
                    link.click();
                    loadImage(true);
                } else {
                    console.log('Failed to checkout file ' + getImageUrl(img));
                }
            });
    };

    const handleCheckinImage = () => {
        setCheckinDialogOpen(true);
    };

    const handleCheckinDialogSave = (data) => {
        setCheckinDialogOpen(false);
        console.log('Checkin data: ' + JSON.stringify(data));
        netPost('/api/catalog/image/checkin', data)
            .then(response => {
                if ( response.ok ) {
                    setSerial(serial => serial + 1);
                    loadImage(true);
                } else {
                    console.log('Failed to checkin image: ' + response.status );
                }
            });
    };

    const handleRevokeCheckoutImage = () => {
        netGet(`/api/catalog/image/revoke/${img.name}`)
            .then(response => {
                if ( response.ok ) {
                    console.log('revoked image: ' + img.name);
                    loadImage(true);
                } else {
                    console.log('Failed to revoke checkout file ' + getImageUrl(img));
                }
            });
    };

    const handleSplitSizeChange = (value) => {
        setSplitSizes(value);
        const v = imageViewerSizeChange + 1;
        // console.log('size change: ' + v);
        setImageViewerSizeChange(v);
        postal.publish('app.catalog.viewer.resize', { resize: true});
    };

    const handleEditClick = () => {
        setPropertiesDialogOpen(true);
    };

    const handleEditSave = (image) => {
        setPropertiesDialogOpen(false);
        console.log("Image to save: " + JSON.stringify(image));
        const data = {
            categories: Array.isArray(image.categories) ? image.categories.map(c => c.name) : [],
            image: image.info,
            effectivity: image.effectivity,
        };
        netPost('/api/catalog/image/save', data)
            .then(response => {
                if ( response.ok ) {
                    setSerial(serial => serial + 1);
                    loadImage(true);
                } else {
                    console.log('Failed to save image: ' + response.status );
                }
            });
    };

    const isAudioOrVideo = () => {
        if ( facet?.contentType ) {
            return facet.contentType.includes('audio') || facet.contentType.includes('video');
        }
        if ( imageInfo?.info?.type ) {
            return imageInfo.info.type.includes('audio') || imageInfo.info.type.includes('video');
        }
        return img?.type?.includes('audio') || img?.type?.includes('video');
    }

    const getUsages = () => {
        console.log('Refs: ' + JSON.stringify(imageInfo?.info?.properties));
        const refs = [];
        const rsmap = imageInfo?.info?.properties?.refs;
        let refMap = {};
        if ( typeof rsmap === 'string') {
            refMap = JSON.parse(rsmap);
        }
        console.log('refMap: ' + JSON.stringify(refMap));
        Object.keys(refMap).forEach( id => {
            const i = refMap[id].indexOf(':');
            if (i >= 0) {
                const doc = refMap[id].substring(0, i);
                if (!refs.includes(doc)) {
                    refs.push(doc);
                }
            }
        });
        return refs.reduce((sum, doc) => sum === '' ? doc : sum + ', ' + doc, '');
    }

    return (
        <Box sx={{position: 'relative', height: '100%'}}>
            <SplitPane
                style={{height: '100%'}}
                split="vertical"
                sizes={splitSizes}
                onChange={handleSplitSizeChange}
            >
                <Pane style={{padding: '1em', display: 'flex', flexDirection: 'column'}}>
                    <Typography variant="h5" sx={{fontWeight: 'bold', pb: 3}}>Properties</Typography>
                    <Box sx={{display: 'flex', alignItems: 'center'}}>
                        <Typography sx={{width: '7.5em'}} >ID</Typography>
                        <TextField slotProps={{input: {readOnly: true}}} value={img?.name} size="small" fullWidth />
                    </Box>
                    <Box sx={{display: 'flex', alignItems: 'center', pt: 2}}>
                        <Typography sx={{width: '7.5em'}} >Label</Typography>
                        <TextField slotProps={{input: {readOnly: true}}}  value={imageInfo?.info?.label} size="small" fullWidth />
                    </Box>
                    <Box sx={{display: 'flex', alignItems: 'flex-start', pt: 2}}>
                        <Typography sx={{width: '7.5em'}} >Description</Typography>
                        <TextField slotProps={{input: {readOnly: true}}} value={imageInfo?.info?.description} size="small" multiline rows={3} fullWidth/>
                    </Box>
                    <Box sx={{display: 'flex', alignItems: 'center', pt: 2}}>
                        <Typography sx={{width: '7.5em'}} >Type</Typography>
                        <TextField slotProps={{input: {readOnly: true}}}  value={img?.type} size="small" fullWidth />
                    </Box>
                    
                    <Box sx={{display: 'flex', alignItems: 'flex-start', pt: 2}}>
                        <Typography sx={{width: '7.5em'}} >Categories</Typography>
                        <FormControl sx={{ position: 'relative', height: '6em', overflowX: 'auto', width: '100%',
                            borderRadius: '4px', border: '1px solid rgba(0,0,0,0.17)' }} variant="outlined">
                            <List sx={{ padding: 0, margin: 0 }}>
                                {Array.isArray(categories) && categories.map( (cat, index) =>
                                    <ListItemButton
                                        sx={{padding: 0, pl: 1}}
                                        selected={selectedCateg === index}
                                        onClick={(event) => handleCategSelect(cat, index, event)}
                                        >
                                        <ListItemText>{cat.name}</ListItemText>
                                    </ListItemButton>
                                )}
                            </List>
                        </FormControl>
                    </Box>
                    <Box sx={{display: 'flex', alignItems: 'flex-start', pt: 2}}>
                        <Typography sx={{width: '7.5em'}} >Effectivity</Typography>
                        <FormControl sx={{ position: 'relative', height: '6em', overflowX: 'auto', width: '100%',
                            borderRadius: '4px', border: '1px solid rgba(0,0,0,0.17)' }} variant="outlined">
                            <List sx={{ padding: 0, margin: 0 }}>
                                {Array.isArray(effectivity) && effectivity.map( (eff, index) =>
                                    <ListItemButton
                                        sx={{padding: 0, pl: 1}}
                                        selected={selectedEff === index}
                                        onClick={(event) => handleEffSelect(eff, index, event)}
                                        >
                                        <ListItemText>{eff}</ListItemText>
                                    </ListItemButton>
                                )}
                            </List>
                        </FormControl>
                    </Box>
                    {dimensions && dimensions !== '' && 
                        <Box sx={{ display: 'flex', alignItems: 'center', pt: 2 }}>
                            <Typography sx={{ width: '7.5em' }} >Dimensions</Typography>
                            <TextField slotProps={{ input: { readOnly: true } }} value={dimensions} size="small" fullWidth />
                        </Box>
                    }
                    <Box sx={{display: 'flex', alignItems: 'center', pt: 2}}>
                        <Typography sx={{width: '7.5em'}} >File Size</Typography>
                        <TextField slotProps={{input: {readOnly: true}}}  value={imageInfo?.sizeText} size="small" fullWidth />
                    </Box>
                    <Box sx={{display: 'flex', alignItems: 'center', pt: 2}}>
                        <Typography sx={{width: '7.5em'}} >Last Modified</Typography>
                        <TextField slotProps={{input: {readOnly: true}}}  value={imageInfo?.lastModified} size="small" fullWidth />
                    </Box>
                    <Box sx={{display: 'flex', alignItems: 'center', pt: 2}}>
                        <Typography sx={{width: '7.5em'}} >Version</Typography>
                        <TextField slotProps={{input: {readOnly: true}}}  value={imageInfo?.version} size="small" fullWidth />
                    </Box>
                    <Box sx={{display: 'flex', alignItems: 'center', pt: 2}}>
                        <Typography sx={{width: '7.5em'}} >Locked By</Typography>
                        <TextField slotProps={{input: {readOnly: true}}}  value={imageInfo?.info?.lock ? imageInfo.info.lock : ''} size="small" fullWidth />
                    </Box>
                    <Box sx={{display: 'flex', alignItems: 'center', pt: 2}}>
                        <Typography sx={{width: '7.5em'}} >Used By</Typography>
                        <TextField slotProps={{input: {readOnly: true}}}  value={getUsages()} size="small" fullWidth />
                    </Box>
                    <Box sx={{flexGrow: 1, display: 'flex', alignItems: 'flex-end'}}>
                        <Tooltip title="Edit">
                            <IconButton onClick={handleEditClick} disabled={readOnly}>
                                <EditIcon fontSize="inherit" />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Pane>
                <Box sx={{position: 'relative', height: '100%', display: 'flex', alignContent: 'center', justifyContent: 'center', flexWrap: 'wrap',
                    borderLeft: '2px solid rgba(0,0,0,0.17)', padding: '2px',
                }}>
                    {isAudioOrVideo() ?
                        <ReactPlayer src={getImageUrl(img)} playing={false} controls={true} />
                        :
                        <PictureViewer src={getImageUrl(img)} name={img?.label} sizeChange={splitSizes} />
                    }
                    
                </Box>
            </SplitPane>
            {/* 
            <Box sx={{height: '3.9em', padding: 1, pt: '5px', pb: '3px'}}>
                <Tooltip title="Export image">
                    <Button variant="outlined" startIcon={<FileDownloadIcon/>} onClick={handleExportImage}>Export</Button>
                </Tooltip>
                <Tooltip title="Checkout image">
                    <Button variant="outlined" startIcon={<OutputIcon/>} onClick={handleCheckoutImage} sx={{ml: 2}} disabled={imageInfo?.info?.lock}>Checkout</Button>
                </Tooltip>
                <Tooltip title="Revoke checkout">
                    <Button variant="outlined" startIcon={<LockResetIcon/>} onClick={handleRevokeCheckoutImage} sx={{ml: 2}} disabled={!imageInfo?.info?.lock}>Revoke</Button>
                </Tooltip>
                <Tooltip title="Checkin image">
                    <Button variant="outlined" startIcon={<InputIcon/>} onClick={handleCheckinImage} sx={{ml: 2}} disabled={!imageInfo?.info?.lock}>Checkin</Button>
                </Tooltip>
            </Box>
            */}
            <Tooltip title="Close">
                <IconButton onClick={handlePanelClose} sx={{position: 'absolute', top: '0.75em', right: '0.6em', zIndex: 40, 
                    }}>
                    <CloseIcon fontSize="inherit" />
                </IconButton>
            </Tooltip>
            <ImportImageDialog open={checkinDialogOpen} image={imageInfo?.info} categs={imageInfo?.categories?.map(c => c.name)} 
                title={`Checkin Image ${img.label}`} onCancel={() => setCheckinDialogOpen(false)} checkin={true}
                onSave={handleCheckinDialogSave} okLabel="Checkin" />
            <ImagePropertyDialog open={propertiesDialogOpen} onCancel={() => setPropertiesDialogOpen(false)} 
                onSave={handleEditSave} image={imageInfo} categories={allCategories} />
        </Box>
    );
}

function EffectivityChooserDialog(props) {
    const {
        open,
        title="Choose Effectivity",
        namespace='NZ_AIRCRAFT',
        onSave,
        onCancel,
        ...other
    } = props;


    const [effNamespace, setEffNamespace] = useState('NZ_AIRCRAFT');
    const [effValue, setEffValue] = useState('');
    const [okEnabled, setOkEnabled] = useState(false);
    const [effModel, setEffModel] = useState([]);
    const [effModelIdMap, setEffModelIdMap] = useState({});
    const [effModelLabelMap, setEffModelLabelMap] = useState({});
    const [effItems, setEffItems] = useState([]);

    useEffect(() => {
        if ( open ) {
            setEffNamespace(namespace);
            setEffItems([]);
        }
    },[open, namespace]);

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if (reason === 'backdropClick') {
            return;
        }
        if (typeof onCancel === 'function') {
            onCancel();
        }
    };


    const onOkClick = () => {
        if (typeof onSave === 'function') {
            const vv = effItems.map( id => {
                const item = effModelIdMap[id];
                if ( item ) {
                    if ( item.type === 'group' ) {
                        return item.group?.description;
                    } else if ( item.type === 'stmt') {
                        return item.stmt?.statement;
                    }
                }
            });
            onSave(vv);
        }
    }

    const handleEffItemsChange = (event, ids) => {
        // console.log('Items change value: ' + JSON.stringify(ids));
        setOkEnabled(Array.isArray(ids) && ids.length > 0);
        setEffItems(ids);
        const titems = ids.map( id => {
            const item = effModelIdMap[id];
            if ( item ) {
                return { type: item.type, label: item.group?.description, stmt: item.stmt?.statement };
                /*
                return {
                    key: item.id,
                    data: {
                        item: {
                          type: item.type,
                          id: item.id,
                          seq: item.seq ? item.seq : -1,
                          label: item.label,
                          parentLabel: item.parentLabel,
                          ancestorLabels: getAncestorLabels(item.parentLabel),
                          name: item.name,
                          group: item.group,
                          stmt: item.stmt,
                          eff: item.eff,  
                        },
                        color: '#000',
                        ename: item.name,
                        elabel: item.label,
                        eparent: item.parentLabel,
                    },
                    children: [],
                };
                */
            }
            return '';
        });
        console.log('ITEMS: ' + JSON.stringify(titems));
    };

    const loadModelMap = (model, idmap, labelmap) => {
        if (Array.isArray(model) && model.length > 0 ) {
            model.forEach(item => {
                idmap[item.id] = item;
                labelmap[item.label] = item;
                loadModelMap(item.children, idmap, labelmap);
            });
        }
    };

    const handleEffModelChange = (model) => {
        setEffModel(model);
        const idmap = {};
        const labelmap = {};
        loadModelMap(model, idmap, labelmap);
        setEffModelIdMap(idmap);
        setEffModelLabelMap(labelmap);
    };

    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 600,
                        maxWidth: 600,
                        maxHeight: 550,
                        minHeight: 400,
                    }
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
            <DialogContent>
                <Box sx={{ height: '100%', overflow: 'auto' }}>
                    <EffectivityChooser namespace={effNamespace} onSelectedItemsChange={handleEffItemsChange} onModelChange={handleEffModelChange} />
                </Box>
            </DialogContent>
            <DialogActions sx={{ padding: 3, paddingTop: 1 }}>
                <Button variant="outlined" onClick={() => onOkClick()} sx={{ minWidth: '7em' }} disabled={!okEnabled} >OK</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', marginLeft: 2 }}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
}

function OptionsSelectionDialog(props) {
    const {
        open,
        options,
        title = 'Select Option',
        headerLabel = 'Options',
        onSave,
        onCancel,
        ...other
    } = props;

    const [selectedOption, setSelectedOption] = useState([]);
    const [okEnabled, setOkEnabled] = useState(false);

    const theme = useTheme();

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        slotProps: {
            paper: {
                style: {
                    maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                    width: 250,
                },
            },
        },
    };

    useEffect(() => {
        if ( open ) {
            setOkEnabled(false);
            setSelectedOption([]);
        }
    },[open]);

    const onOkClick = () => {
        if (typeof onSave === 'function') {
            onSave(selectedOption);
            console.log('Adding CATEGS: ' + JSON.stringify(selectedOption));
        }
    };

    const onCancelClick = () => {
        onClose();
    };

    const onClose = () => {
        if (typeof onCancel === 'function') {
            onCancel();
        }
    };

    const handleOptionChange = (value) => {
        const oo = [...selectedOption];
        if ( oo.includes(value) ) {
            const i = oo.findIndex( o => o === value);
            if ( i >= 0 ) {
                oo.splice(i, 1);
            }
        } else {
            oo.push(value);
        }
        setSelectedOption(oo);
        // setSelectedOption(value);
        setOkEnabled(true);
    };

    const getStyles = (name, selection, theme) => {
        return {
            fontWeight: selection.includes(name)
                ? theme.typography.fontWeightMedium
                : theme.typography.fontWeightRegular,
        };
    };

    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 600,
                        maxWidth: 600,
                        maxHeight: 550,
                        minHeight: 400,
                    }
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
            <DialogContent sx={{pb: 3}}>
                <FormControl sx={{ width: '100%', position: 'relative', height: '300px' }}>
                    <List sx={{ padding: 0, margin: 0 }}>
                        {Array.isArray(options) && options.sort((a, b) => a.localeCompare(b)).map((cat, index) =>
                            <ListItemButton
                                sx={{ padding: 0, pl: 1 }}
                                selected={selectedOption.includes(cat)}
                                onClick={(event) => handleOptionChange(cat, index, event)}
                            >
                                <ListItemText>{cat}</ListItemText>
                            </ListItemButton>
                        )}
                    </List>
                    {/* 
                    <Select
                        labelId="opt-multiple-name-label77"
                        id="opt-multiple-name"
                        multiple
                        value={selectedOption}
                        onChange={handleOptionChange}
                        input={<OutlinedInput label={headerLabel} />}
                        MenuProps={MenuProps}
                    >
                        {Array.isArray(options) && options.map((option) => (
                            <MenuItem
                                key={option}
                                value={option}
                                style={getStyles(option, selectedOption, theme)}
                            >
                                {option}
                            </MenuItem>
                        ))}
                    </Select>
                    */}
                </FormControl>
            </DialogContent>
            <DialogActions sx={{ padding: 3, paddingTop: 1 }}>
                <Button variant="outlined" onClick={() => onOkClick()} sx={{ minWidth: '7em' }} disabled={!okEnabled} >OK</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', marginLeft: 2 }}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );

}

function MultipleSelectionEditor(props) {
    const {
        headerLabel,
        addActionLabel = 'Add',
        deleteActionLabel = 'Delete',
        sort=true,
        values = [],
        options = [],
        onAddClick,
        onChange,
        onCancel,
        ...other
    } = props;

    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [deleteActionEnabled, setDeleteActionEnabled] = useState(false);
    const [myValues, setMyValues] = useState([]);
    const [optionsDialogOpen, setOptionsDialogOpen] = useState(false);

    useEffect(() => {
        if (Array.isArray(values) ) {
            const vv = [...values];
            setMyValues(vv);
        }
    },[values]);

    const handleRowClicked = (event, index) => {
        setSelectedIndex(index);
        setDeleteActionEnabled(index >= 0);
    };

    const isRowSelected = (index) => {
        return selectedIndex === index;
    };

    const handleAddActionClick = () => {
        if ( typeof onAddClick === 'function' ) {
            onAddClick();
        } else {
            setOptionsDialogOpen(true);
        }
    };

    const handleDeleteActionClick = () => {
        if ( selectedIndex >=0 && selectedIndex < values.length ) {
            const v = [...myValues];
            v.splice(selectedIndex, 1);
            setSelectedIndex(-1);
            setMyValues(v);
            if ( typeof onChange === 'function') {
                onChange(v);
            }
        }
    };

    const handleOptionsSave = (value) => {
        setOptionsDialogOpen(false);
        const vv = [...myValues];
        if ( Array.isArray(value) ) {
            value.forEach( v => {
                if ( !vv.includes(v) ) {
                    vv.push(v);
                }
            });
        }
        vv.sort( (a,b) => a.localeCompare(b) ) ;
        setMyValues(vv);
        if (typeof onChange === 'function') {
            onChange(vv);
        }
    };

    return (
        <Box sx={{ paddingTop: '0.5ex', display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
            <Box sx={{ width: '100%', paddingTop: '1ex', paddingRight: 0, paddingBottom: 0 }}>
                <TableContainer component={Paper} sx={{ height: '9em', paddingBottom: 0, marginBottom: 0 }}>
                    <Table stickyHeader sx={{ minWidth: '350px', paddingBottom: 0}} aria-label="selection table" size="small">
                        <TableHead>
                            <TableRow sx={{ paddingTop: 0, paddingBotton: 0 }}>
                                <TableCell sx={{ paddingTop: '1.5ex', paddingBottonm: 0, lineHeight: '0.9rem', fontWeight: 'bold' }}>{headerLabel}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {myValues.sort( (a,b) => a.localeCompare(b)).map((row, index) => (
                                <TableRow
                                    key={`${stringHash(row)}-${index}`}
                                    onClick={(event) => handleRowClicked(event, index)}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    selected={isRowSelected(index)}
                                >
                                    <TableCell sx={{ paddingTop: '1.5ex', paddingBottom: 0, lineHeight: '0.9rem', borderBottom: 0 }}>{row}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                
            </Box>
            <Box sx={{ paddingTop: '0px', paddingLeft: '0px' }}>
                <Tooltip title={addActionLabel}>
                    <IconButton color="primary" onClick={handleAddActionClick}>
                        <AddBoxIcon fontSize="inherit" />
                    </IconButton>
                </Tooltip>
                <Tooltip title={deleteActionLabel}>
                    <IconButton disabled={!deleteActionEnabled} onClick={handleDeleteActionClick} color="error" sx={{ marginLeft: 0 }} >
                        <DeleteIcon fontSize="inherit" />
                    </IconButton>
                </Tooltip>
            </Box>
            <OptionsSelectionDialog open={optionsDialogOpen} onCancel={() => setOptionsDialogOpen(false)}
                options={options} onSave={handleOptionsSave} title="Select Category" headerLabel="Categories" />
        </Box>
    );

}

function ImagePropertyDialog(props) {
    const {
        open,
        title="Edit Image Properties",
        image,
        categories,
        onSave,
        onCancel,
        ...other
    } = props;

    const [labelValue, setLabelValue] = useState('');
    const [descValue, setDescValue] = useState('');
    const [categValue, setCategValue] = useState([]);
    const [effValue, setEffValue] = useState([]);
    const [okEnabled, setOkEnabled] = useState(false);
    const [allCategValue, setAllCategValue] = useState([]);
    const [allCategNames, setAllCategNames] = useState([]);
    const [effDialogOpen, setEffDialogOpen] = useState(false);

    useEffect(() => {
        if ( open && image) {
            setOkEnabled(false);
            setLabelValue(image.info?.label ? image.info.label : '');
            setDescValue(image.info?.description ? image.info.description : '');
            if ( Array.isArray(image.categories) ) {
                setCategValue(image.categories.map( c => c.name));
            } else {
                setCategValue([]);
            }
            if ( Array.isArray(image.effectivity) ) {
                setEffValue(image.effectivity);
            } else {
                setEffValue([]);
            }
        }

    },[open,image])

    useEffect(() => {
        if ( Array.isArray(categories) ) {
            setAllCategValue(categories);
            setAllCategNames(categories.map( c => c.name));
        }
    },[categories]);

    const onCancelClick = () => {
        onClose();
    };

    const onClose = (event, reason) => {
        if (reason === 'backdropClick') {
            return;
        }
        if (typeof onCancel === 'function') {
            onCancel();
        }
    };


    const onOKClick = () => {
        if (typeof onSave === 'function') {
            const img = {...image};
            if ( !img.info ) {
                img.info = {};
            }
            img.info.label = labelValue;
            img.info.description = descValue;
            const cc = allCategValue.filter( c => categValue.includes(c.name));
            // console.log('CATEG VALUE: ' + JSON.stringify(cc));
            img.categories = cc;
            img.effectivity = effValue;
            onSave(img);
        }
    }
    
    const propsValid = (lv=labelValue) => {
        return (typeof lv === 'string') && lv.length > 0;
    }

    const handleLabelChange = (event) => {
        setLabelValue(event.target.value);
        setOkEnabled(propsValid(event.target.value));
    }

    const handleDescriptionChange = (event) => {
        setDescValue(event.target.value);
        setOkEnabled(propsValid(labelValue));
    };

    const handleCategChange = (value) => {
        setCategValue(value);
        setOkEnabled(propsValid(labelValue));
    };

    const handleEffChange = (value) => {
        setEffValue(value);
        setOkEnabled(propsValid(labelValue));
    };

    const handleEffAddClick = () => {
        setEffDialogOpen(true);
    };

    const handleEffSave = (data) => {
        setEffDialogOpen(false);
        // console.log('EFF: ' + JSON.stringify(data));
        const ee = [...effValue];
        if ( Array.isArray(data) ) {
            data.forEach( e => {
                if ( !ee.includes(e) ) {
                    ee.push(e);
                }
            })
        }
        ee.sort( (a,b) => a.localeCompare(b));
        setEffValue(ee);
        setOkEnabled(propsValid(labelValue));
    };

    return (
        <Dialog
            maxWidth={'900px'}
            open={open}
            onClose={onClose}
            slotProps={{
                paper: {
                    sx: {
                        minWidth: 780,
                        maxWidth: 800,
                        maxHeight: 720,
                        minHeight: 400,
                    }
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
            <DialogContent>
                <TextField label="Label" value={labelValue} onChange={handleLabelChange} fullWidth size="small" sx={{ marginTop: 2 }} />
                <TextField label="Description" value={descValue} onChange={handleDescriptionChange} fullWidth size="small" sx={{ marginTop: 2 }}
                    multiline rows="3" />
                <MultipleSelectionEditor headerLabel="Categories" addActionLabel="Add Category" deleteActionLabel="Delete Category" 
                   values={categValue} options={allCategNames} onChange={handleCategChange} />
                <MultipleSelectionEditor headerLabel="Effectivity" addActionLabel="Add Effectivity" deleteActionLabel="Delete Effectivity" 
                   values={effValue}  onChange={handleEffChange} onAddClick={handleEffAddClick} />
                <EffectivityChooserDialog open={effDialogOpen} onCancel={() => setEffDialogOpen(false)} 
                    onSave={handleEffSave} />
            </DialogContent>
            <DialogActions sx={{ padding: 3, paddingTop: 1 }}>
                <Button variant="outlined" onClick={() => onOKClick()} sx={{ minWidth: '7em' }} disabled={!okEnabled} >Save</Button>
                <Button variant="outlined" onClick={onCancelClick} sx={{ minWidth: '7em', marginLeft: 2 }}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
}

function ImagePanel(props) {

    const [gid, setGid] = useState(0);
    const [images, setImages] = useState([]);
    const [filteredImages, setFilteredImages] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchUse, setSearchUse] = useState('all');
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [selectedImageName, setSelectedImageName] = useState('');
    const [selectedImageLabel, setSelectedImageLabel] = useState('');
    const [rows, setRows] = useState(11 * 7);
    const [firstPage, setFirstPage] = useState(0);
    const [pageSize, setPageSize] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [windowHeight, setWindowHeight] = useState(window.innerHeight - 54 - 100);
    const [splitMode, setSplitMode] = useState(false);
    const [importDialogOpen, setImportDialogOpen] = useState(false);
    const [checkinDialogOpen, setCheckinDialogOpen] = useState(false);
    const [deleteImageDialogOpen, setDeleteImageDialogOpen] = useState(false);
    const [revokeImageDialogOpen, setRevokeImageDialogOpen] = useState(false);
    const [usageLastUpdated, setUsageLastUpdated] = useState('');
    const theme = useTheme();
    const categories = useSelector((state) => state.catalog.categories);
    const menuSplitMode = useSelector( (state) => state.menu.splitMode);
    const readOnly = useSelector( (state) => state.catalog.readOnly);
    const panelElem = useRef(null);

    useEffect( () => {
        resizeHandler();
        window.addEventListener('resize', resizeHandler);
        const imageSub = postal.subscribe(
            'app.catalog.image.change',
            handlePostalImageChange,
        );
        const splitSub = postal.subscribe(
            'app.menu.window.split',
            (envelop) => {
                setSplitMode(envelop.payload.split);
                catalogSplitMode = envelop.payload.split;
            }
        );
        loadLastUpdated();
        return () => {
            window.removeEventListener('resize', resizeHandler);
            imageSub();
            splitSub();
        };
    },[]);

    useEffect(() => {
        loadImages();
        globalSelectedCategories = [...categories];
    },[categories]);

    const loadLastUpdated = () => {
        netGet('/api/catalog/reports/info').then( result => result.json())
            .then( info => {
                if ( info?.usageLastUpdated ) {
                    setUsageLastUpdated(info.usageLastUpdated);
                }
            }).catch(error => console.log('Error fetching report info: ' + error));
    };

    const loadImages = (dontSelect=false, global=false) => {
        setSelectedImage(null);
        setSelectedIndex(-1);
        const categs = global ? [...globalSelectedCategories] : [...categories];
        let cats = '';
        if (Array.isArray(categs)) {
            cats = categs.reduce((a, b) => a.length > 0 ? a + ',' + b : b, '');
            // console.log('itemIds=' + JSON.stringify(itemIds) + ', cat=' + cats);
            netGet('/api/catalog/image' + (categs.length > 0 ? '?cat=' + encodeURIComponent(cats) : ''))
                .then(response => response.json())
                .then(data => {
                    if (Array.isArray(data)) {
                        data.sort( (a,b) => a.label?.localeCompare(b.label));
                        setImages(data);
                        if (selectedImageName && selectedImageName !== '') {
                            const imageIndex = data.findIndex(img => img.name === selectedImageName);
                            if (imageIndex >= 0) {
                                // setImages(data);
                                const image = data[imageIndex];
                                setSelectedImage(image);
                                setSelectedImageLabel(image.label);
                                setSelectedIndex(imageIndex);
                            }
                        }
                        loadFilteredImages(globalSearchTerm, data, globalSearchUse, dontSelect);
                    }
                }).catch(error => console.log('Failed to retrieve image info: ' + error));
        }
        loadLastUpdated();
    };

    const resizeHandler = (entries=filteredImages, dontResetPage=false) => {
        // console.log('resize: dontResetPage=' + dontResetPage);
        let h = window.innerHeight - 210;
        let w = window.innerWidth - 270;
        console.log("Catalog resize: split = " + menuSplitMode + ',' + splitMode + ',' + catalogSplitMode);
        if ( menuSplitMode || splitMode || catalogSplitMode) {
            w = Math.floor(w / 2);
        }
        /*
        if ( panelElem.current ) {
            const r = panelElem.current.getBoundingClientRect();
            if ( r ) {
                w = r.width;
                h = r.height;
            }
        }
        */
        setWindowHeight(h);
        console.log('RESIZE Image panel size: ' + w + ' / ' + h);
        const r = Math.floor((h / (92+15)) - 2) * Math.floor((w / (92+5)) - 1);
        // console.log('Image page size: ' + r);
        setRows(r);
        // if ( Array.isArray(entries) && entries.length > 0 ) {
        if ( filteredImageCount > 0 ) {
            // console.log('Image count: ' + filteredImageCount);
            let pc = filteredImageCount / r;
            const rc = filteredImageCount % r;
            if ( rc === 0 ) {
                pc += 1;
            }
            if (!dontResetPage) {
                setFirstPage(0);
            }
            setPageCount(pc);
            setPageSize(r);
        } else {
            // console.log('Image count = 0');
            setFirstPage(0);
            setPageCount(1);
            setPageSize(r);
        }
        // setGid( gid => gid + 1);
    };

    const handlePostalImageChange = (envelope) => {
        // console.log('Image changed: ' + JSON.stringify(envelope.payload));
        loadImages(true, true);
    };

    const loadFilteredImages = (term, timages, usage=searchUse, dontResetPage=false) => {
        console.log('loadFiltered: ' + term + ', usage=' + usage + ', dontResetPage=' + dontResetPage);
        const lterm = typeof term === 'string' ? term.toLowerCase().trim() : '';
        let fimages = [...timages];
        // console.log('lterm: ' + lterm + ' : ' + fimages.length);
        if (lterm && lterm !== '' ) {
            fimages = timages.filter(img => {
                const lname = typeof img.name === 'string' ? img.name.toLowerCase() : '';
                const llabel = typeof img.label === 'string' ? img.label.toLowerCase() : '';
                
                return (lname.includes(lterm) || llabel.includes(lterm) );
            });
        }
        if ( usage !== 'all' ) {
            const uimages = fimages.filter ( img => {
                let useSelect = true;
                if ( usage === 'inuse' ) {
                    useSelect = ( img.properties?.inUse === '1' );
                } else if ( usage === 'notused') {
                    useSelect = img.properties?.inUse !== '1';
                }
                return useSelect;
            });
            fimages = uimages;
        }
        filteredImageCount = fimages.length;
        resizeHandler(fimages, dontResetPage);
        setFilteredImages(fimages);
    };

    const getImageExtension = (image) => {
        const t = image.type;
        if (t.includes('png')) {
            return '.png';
        }
        if (t.includes('jpeg')) {
            return '.jpg';
        }
        if (t.includes('pdf')) {
            return '.pdf';
        }
        if (t.includes('gif')) {
            return '.gif';
        }
        if (t.includes('svg')) {
            return '.svg';
        }
    }

    const getImageUrl = (image) => {
        // thumbnail is always PNG
        const url = new URL('/api/fs' + image.path + '/THUMB.png', window.location.href);
        return url.toString();
    }

    const getMainImageUrl = (image) => {
        const url = new URL('/api/fs' + image.path + '/MAIN' + getFileExtension(image?.type), window.location.href);
        return url.toString();
    }

    const itemTemplate = (item, index) => {
        const selected = item.name === selectedImageName;
        return (
            <Tooltip title={
                <Box>
                    <Typography sx={{ fontWeight: 'bold' }}>{item.name}</Typography>
                    <Typography>{item.label}</Typography>
                    {item.lock &&
                    <Typography>{`Lock: ${item.lock}`}</Typography>
                    }
                </Box>
            }>
                <Box sx={{ width: '104px', padding: 0, margin: 0 }}>
                    <IconButton onClick={(event) => handleImageClick(item, index, event)}
                        sx={{
                            border: selected ? '3px solid red' : '3px solid transparent', borderRadius: 0,
                            backgroundColor: selected ? 'gray' : 'white',
                            padding: 0,
                            margin: 0,
                            position: 'relative',
                        }} >
                        <img
                            style={{ height: '92px', width: '92px', maxHeight: '92px', maxWidth: '92px', opacity: selected ? 0.6 : 1 }}
                            src={getImageUrl(item)}
                            alt={item.label}
                            loading="lazy"
                        />
                        {typeof item.lock === 'string' && item.lock.length > 0 &&
                            <SvgIcon fontSize="10px" sx={{ position: 'absolute', top: '68px', left: '-4px', zIndex: 50 }} >
                                <svg version="1.1" id="LockBrass" x="0px"
                                    y="0px" viewBox="0 0 32 32" enable-background="new 0 0 32 32" >
                                    <g>
                                        <path marker-start="none" marker-end="none" fill-rule="evenodd" clip-rule="evenodd" fill="#d9a025" 
                                        d="M6.99,19.92v-8c0-4.97,4.03-9,9-9c4.97,0,9,4.03,9,9l0,8c0,0.55-0.45,1-1,1h-2c-0.55,0-1-0.45-1-1l0-8c0-2.76-2.24-5-5-5c-2.76,0-5,2.24-5,5v8c0,0.55-0.45,1-1,1h-2C7.44,20.92,6.99,20.47,6.99,19.92z"/>
                                        <path marker-start="none" marker-end="none" fill-rule="evenodd" clip-rule="evenodd" fill="#d9a025" 
                                        d="M4.99,30.92v-17h22v17H4.99z"/>
                                        <rect x="15" y="20.92" fill-rule="evenodd" clip-rule="evenodd" fill="#262629" width="2" height="5" />
                                        <circle fill-rule="evenodd" clip-rule="evenodd" fill="#262629" cx="16" cy="20.92" r="2" />
                                    </g>
                                </svg>
                            </SvgIcon>
                        }
                        {item?.properties?.inUse === '1' ?
                            <CheckCircleIcon fontSize="6px" sx={{position: 'absolute', top: '-2px', left: '70px', zIndex: 50}} color="success"/> :
                            <CancelIcon fontSize="6px" sx={{position: 'absolute', top: '-2px', left: '70px', zIndex: 50}} color="error" />
                        }
                    </IconButton>
                    <Typography sx={{ fontSize: '8pt', overflow: 'clip', padding: '4px', textWrap: 'nowrap', textOverflow: 'ellipsis' }}>{item.label}</Typography>
                </Box>
            </Tooltip>
        );
    };


    const listTemplate = (items, layout) => {
        return <Box sx={{
            border: '1px solid green',
            display: 'flex', flexWrap: 'wrap', alignItems: 'center',
            position: 'relative',
            rowGap: '15px', columnGap: '5px', height: windowHeight, alignContent: 'flex-start'
        }}>{items.map((item, index) => itemTemplate(item, layout, index))}</Box>;
    };

    const handleImageClick = (image, index, event) => {
        setSelectedImage(image);
        setSelectedIndex(index);
        setSelectedImageName(image.name);
        setSelectedImageLabel(image.label);
        // console.log('Selected Image: ' + JSON.stringify(image));
        if ( event.detail > 1 ) {
            console.log('Opening ImageViewer with ' + JSON.stringify(image));
            MediaCatalogModule.setCard({
                page: <ImageViewer img={image} />,
                name: 'image',
                permanent: false,
                reuse: false,
                right: true,
                includeModules: ['workflow', 'dlib'],
                label: 'Image Viewer',
                origin: 'graphics',
                icon: <PreviewIcon fontSize="inherit" />
            });
        }
    };

    const onPageChange = (event) => {
        console.log('Image page: ' + event.first);
        setFirstPage(event.first);
        setSelectedImage(null);
        setSelectedIndex(-1);
    };

    const debouncedSearchTermChangeHandler = React.useCallback(
        debounce((value, timages) => {
            // Perform your action here with the debounced value
            // console.log('Debounced value:', value);
            loadFilteredImages(value, timages);
            globalSearchTerm = value;
            setSearchTerm(value);
        }, 1500), // Debounce delay in milliseconds
        []
    );

    const searchTermChange = (event) => {
        // setSearchTerm(event.target.value);
        debouncedSearchTermChangeHandler(event.target.value, images);
    };

    const handleSearchUseChange = (event) => {
        globalSearchUse = event.target.value;
        setSearchUse(event.target.value);
        loadFilteredImages(searchTerm, images, event.target.value);
    }

    const handleImportAction = () => {
        setImportDialogOpen(true);
    };

    const handleImportImageSave = (data) => {
        setImportDialogOpen(false);
        console.log('Import data: ' + JSON.stringify(data));
        netPost('/api/catalog/image', data)
            .then(response => {
                if ( !response.ok ) {
                    console.log('Error importing graphics: ' + response.status);
                } else {
                    loadImages();
                }
            })
    };

    const handleExportImage = () => {
        if (selectedImage) {
            const iurl = getMainImageUrl(selectedImage);
            console.log('Downloading ' + iurl);
            netGet(iurl)
                .then(response => response.blob())
                .then(blob => {
                    if ( blob ) {
                        saveFile(blob, `${selectedImage.label}${getFileExtension(selectedImage?.type)}`);
                    }
                }).catch(error => console.log('Failed to export file: ' + error));
            /*
            const link = document.createElement('a');
            link.href = iurl;
            link.download = selectedImage.label + getImageExtension(selectedImage);
            link.click();
            */
        }
    };

    const handleCheckoutImage = () => {
        /*
        if (selectedImage?.name) {
            netGet(`/api/catalog/image/checkout/${selectedImage.name}`)
                .then(response => {
                    if (response.ok) {
                        const iurl = getMainImageUrl(selectedImage);
                        console.log('Downloading checkout ' + iurl);
                        netGet(iurl)
                            .then(response => response.blob())
                            .then(blob => {
                                if (blob) {
                                    saveFile(blob, `${selectedImage.label}${getImageExtension(selectedImage)}`);
                                }
                            }).catch(error => console.log('Failed to download checkout file: ' + error));
                        loadImages(true);
                    } else {
                        console.log('Failed to checkout file ' + getImageUrl(selectedImage));
                    }
                });
        }
        */
        if ( selectedImage?.name) {
            window.showSaveFilePicker({ suggestedName: `${selectedImage.label}${getFileExtension(selectedImage?.type)}` })
                .then(newHandle => newHandle.createWritable())
                .then(wstream => {
                    netGet(`/api/catalog/image/checkout/${selectedImage.name}`)
                        .then(response => {
                            if (response.ok) {
                                const iurl = getMainImageUrl(selectedImage);
                                console.log('Downloading checkout ' + iurl);
                                /*
                                const link = document.createElement('a');
                                link.href = iurl;
                                link.download = selectedImage.label + getImageExtension(selectedImage);
                                link.click();
                                */
                                netGet(iurl)
                                    .then(response => response.blob())
                                    .then(blob => {
                                        if (blob) {
                                            blob.stream().pipeTo(wstream);                                            
                                        }
                                    });
                                loadImages(true);
                            } else {
                                console.log('Failed to checkout file ' + getImageUrl(selectedImage));
                            }
                        });
                }).catch(error => console.log('Failed to download checkout file: ' + error));
        }
    };

    const handleRevokeCheckoutImage = () => {
        setRevokeImageDialogOpen(true);
    };

    const handleRevokeCheckoutImageSave = (info) => {
        setRevokeImageDialogOpen(false);
        if (selectedImage?.name) {
            netGet(`/api/catalog/image/revoke/${selectedImage.name}`)
                .then(response => {
                    if (response.ok) {
                        console.log('revoked image: ' + selectedImage.name);
                        loadImages(true);
                    } else {
                        console.log('Failed to revoke checkout file ' + getImageUrl(selectedImage));
                    }
                });
        }
    }

    const handleCheckinImage = () => {
        setCheckinDialogOpen(true);
    };

    const handleCheckinDialogSave = (data) => {
        setCheckinDialogOpen(false);
        console.log('Checkin data: ' + JSON.stringify(data));
        netPost('/api/catalog/image/checkin', data)
            .then(response => {
                if ( response.ok ) {
                    // setSerial(serial => serial + 1);
                    loadImages(true);
                } else {
                    console.log('Failed to checkin image: ' + response.status );
                }
            });
    };

    const handleDeleteImage = () => {
        setDeleteImageDialogOpen(true);
    };

    const handleDeleteImageSave = () => {
        setDeleteImageDialogOpen(false);
        if (selectedImage) {
            netPost('/api/catalog/image/delete', selectedImage)
                .then(response => {
                    if (response.ok) {
                        // setSerial(serial => serial + 1);
                        loadImages(true);
                        setSelectedImage(null);
                        setSelectedIndex(-1);
                    } else {
                        console.log('Failed to delete image: ' + response.status);
                    }
                });
        }
    };

    const canCheckout = () => {
        if ( selectedImage && (typeof selectedImage.lock === 'string' ) && selectedImage.lock.length > 0 ) {
            // console.log('IMAGE: ' + JSON.stringify(selectedImage));
            return false;
        }
        return selectedImage ? true : false;
    }

    const canRevokeCheckout = () => {
        if ( selectedImage && (typeof selectedImage.lock === 'string' ) && selectedImage.lock.length > 0 && (selectedImage.lock === UserInfo.info.name) ) {
            return true;
        } 
        return false;
    }

    

    return (
        <Box sx={{
            paddingTop: 2,
            height: '100%', position: 'relative', paddingLeft: 1,
            borderLeftColor: theme.palette.divider, borderLeftStyle: 'solid', borderLeftWidth: '2px',
            display: 'grid',
            gridTemplateRows: 'min-content 1fr min-content'
        }} >
            <Box sx={{ width: '100%', pb: 2, display: 'flex', alignItems: 'center' }} >
                <TextField
                    defaultValue={searchTerm}
                    onChange={searchTermChange}
                    id="xxe-search"
                    size="small"
                    type="search"
                    sx={{ maxWidth: '500px', minWidth: '25em' }}
                    slotProps={{
                        input: {
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }
                    }}
                />
                {/* <Button variant="outlined" onClick={handleImportAction} sx={{ml: 3}} size="small">Import</Button> */}
                <FormControl sx={{pl: 3}}>
                    <RadioGroup
                        row
                        aria-labelledby={'use-label'}
                        value={searchUse}
                        onChange={handleSearchUseChange}
                        name="radio-buttons-group"
                    >
                        <FormControlLabel value="all" control={<Radio />} label="All" />
                        <FormControlLabel value="inuse" control={<Radio />} label="In Use" />
                        <FormControlLabel value="notused" control={<Radio />} label="Not Used" />
                    </RadioGroup>
                </FormControl>
                <Typography sx={{flexGrow: 1, fontSize: '80%', textAlign: 'right', pr: '5em'}}>{`Usage last updated: ${usageLastUpdated}`}</Typography>
            </Box>
            <Box ref={panelElem} sx={{display: 'flex', rowGap: '15px', columnGap: '5px', alignContent: 'flex-start', flexWrap: 'wrap', alignItems: 'center', height: '100%'}}>
                {Array.isArray(filteredImages) &&
                    filteredImages.slice(firstPage * pageSize, (firstPage+1)*pageSize)
                    .map( (img,index) => itemTemplate(img, index))
                }
            </Box>
            {/* 
            <DataView 
                id={`MCIP0_${gid}`}
                pt={{
                    root: {
                        style: {
                            border: '1px solid blue', height: '100%'}
                        }
                    }
                } 
                value={filteredImages} 
                listTemplate={listTemplate} 
                layout="grid" 
                paginator  
                rows={rows} />
            */}
            <Box sx={{height: '3.9em', padding: 1, pt: '5px', pb: '3px', display: 'flex', alignItems: 'center'}}>
                <Box sx={{ flexGrow: 1 }}>
                    <Tooltip title="Import Image">
                        <IconButton onClick={handleImportAction} disabled={readOnly}>
                            <FileUploadIcon fontSize="inherit" />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Export Image">
                        <IconButton onClick={handleExportImage} disabled={!selectedImage || readOnly}>
                            <FileDownloadIcon fontSize="inherit" />
                        </IconButton>
                        {/* <Button variant="outlined" startIcon={<FileDownloadIcon/>} onClick={handleExportImage}>Export</Button> */}
                    </Tooltip>
                    <Tooltip title="Checkout Image">
                        <IconButton onClick={handleCheckoutImage} disabled={!canCheckout() || readOnly}>
                            <OutputIcon fontSize="inheriti" />
                        </IconButton>
                        {/* <Button variant="outlined" startIcon={<OutputIcon/>} onClick={handleCheckoutImage} sx={{ml: 2}} disabled={imageInfo?.info?.lock}>Checkout</Button> */}
                    </Tooltip>
                    <Tooltip title="Revoke Checkout">
                        <IconButton onClick={handleRevokeCheckoutImage} disabled={!canRevokeCheckout() || readOnly}>
                            <LockResetIcon fontSize="inherit" />
                        </IconButton>
                        {/* <Button variant="outlined" startIcon={<LockResetIcon/>} onClick={handleRevokeCheckoutImage} sx={{ml: 2}} disabled={!imageInfo?.info?.lock}>Revoke</Button> */}
                    </Tooltip>
                    <Tooltip title="Checkin Image">
                        <IconButton onClick={handleCheckinImage} disabled={!canRevokeCheckout() || readOnly} >
                            <InputIcon fontSize="inherit" />
                        </IconButton>
                        {/* <Button variant="outlined" startIcon={<InputIcon/>} onClick={handleCheckinImage} sx={{ml: 2}} disabled={!imageInfo?.info?.lock}>Checkin</Button> */}
                    </Tooltip>
                    <Tooltip title="Delete image">
                        <IconButton onClick={handleDeleteImage} disabled={!canCheckout() || readOnly}>
                            <DeleteIcon fontSize="inherit" />
                        </IconButton>
                    </Tooltip>
                </Box>
                <Paginator first={firstPage} rows={1} totalRecords={pageCount} onPageChange={onPageChange} template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink" 
                    style={{display: 'inline-flex'}} />
            </Box>
            
            <ImportImageDialog open={importDialogOpen} onCancel={() => setImportDialogOpen(false)} 
                onSave={handleImportImageSave} categs={categories}
                />
            <ImportImageDialog open={checkinDialogOpen} image={selectedImage}
                title={`Checkin Image ${selectedImage?.label}`} onCancel={() => setCheckinDialogOpen(false)} checkin={true}
                onSave={handleCheckinDialogSave} okLabel="Checkin" />
            <DeleteImageDialog open={deleteImageDialogOpen} image={selectedImage} onCancel={() => setDeleteImageDialogOpen(false)}
                onSave={handleDeleteImageSave} />
            <RevokeImageDialog open={revokeImageDialogOpen} image={selectedImage} onCancel={() => setRevokeImageDialogOpen(false)}
                onSave={handleRevokeCheckoutImageSave} />
        </Box>
    );
}

function CategoryList(props) {

    const [categories, setCategories] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [categSelection, setCategSelection] = useState([]);
    const [deleteCategEnabled, setDeleteCategEnabled] = useState(false);
    const [addCategoryDialogOpen, setAddCategoryDialogOpen] = useState(false);
    const [deleteCategoryDialogOpen, setDeleteCategoryDialogOpen] = useState(false);
    const [deleteCategory, setDeleteCategory] = useState(null);
    const [deleteIndex, setDeleteIndex] = useState(-1);
    const [readOnly, setReadOnly] = useState(false);
    const theme = useTheme();
    const dispatch = useDispatch();

    useEffect(() => {

        loadCategories((categs) => {
            setSelectedItems(['C00-ALL']);
        });
        /*
        const cs = [...categSelection];
        const cats = cs.map(id => {
            const i = id.indexOf('-');
            if (i >= 0 && i < id.length - 1) {
                const c = id.substring(i + 1);
                // console.log('cat=' + c);
                return c;
            }
            return id;
        }).reduce((a, b) => a.length > 0 ? a + ',' + b : b, '');
        */
        // const cat = cs.map(i => categories[i]).reduce((a, b) => a.length > 0 ? a + ',' + b.name : b.name, '');

        MediaCatalogModule.setCard( {
            page: <ImagePanel />, 
            name: 'graphics', 
            reuse: false, 
            right: true, 
            icon: <PermMediaIcon fontSize="inherit" />, 
            includeModules: ['workflow', 'dlib'],
            label: 'Media List',
            enableRightCloseButton: true,
            origin: 'media',
        });
        netPost('/api/auth/acl/eval', {path: '/C/catalog', action: 'WRITE', subjects: UserInfo.info.roles})
            .then(response => response.json())
            .then(acl => {
                let ro = false;
                if ( acl ) {
                    ro = !acl.result;
                }
                setReadOnly(ro);
                dispatch(setCatalogReadOnly(ro));
                console.log('Catalog ACL readOnly = ' + ro);

            }).catch(error => console.log('Failed to evaluate acl: ' + error));

    }, []);

    const loadCategories = (callback) => {
        netGet('/api/catalog/categ')
            .then(response => response.json())
            .then(categs => {
                if (Array.isArray(categs)) {
                    const sorted = categs.sort( (a,b) => a.name ? (a.name.localeCompare(b?.name)) : 1);
                    setCategories(sorted);
                    if ( typeof callback === 'function') {
                        callback(sorted);
                    }
                    
                    // console.log('Media categoeries: ' + JSON.stringify(categs));
                }
            }).catch(error => console.log('Failed to retrieve categories: ' + error));
    };

    // const imagePanel = <ImagePanel /> ;


    const categItemsChange = (event, itemIds) => {
        if (Array.isArray(itemIds) && itemIds.length > 0 ) {
            const cAll = itemIds.find(t => t === 'C00-ALL');
            if (cAll) {
                setDeleteCategEnabled(false);
                setSelectedItems(['C00-ALL']);
                // setCategSelection([]);
                dispatch(setMediaCategories([]));
            } else {
                setSelectedItems(itemIds);
                setDeleteCategEnabled(true);
                const cats = itemIds.map(id => {
                    const i = id.indexOf('-');
                    if (i >= 0 && i < id.length - 1) {
                        const c = id.substring(i + 1);
                        // console.log('cat=' + c);
                        return c;
                    }
                    return id;
                });
                dispatch(setMediaCategories(cats));
            }
        } else {
            setDeleteCategEnabled(false);
            setSelectedItems(['C00-ALL']);
            // setCategSelection([]);
            dispatch(setMediaCategories([]));
        }
    };

    const handleAddAction = () => {
        setAddCategoryDialogOpen(true);
    };

    const handleCategoryAddSave = (entry) => {
        setAddCategoryDialogOpen(false);
        if ( entry?.name ) {
            netPost('/api/catalog/categ', { name: entry.name, description: entry.description })
                .then(response => response.json())
                .then(categ => {
                    loadCategories((categs) => {
                        const index = categs.findIndex( c => c?.name === categ?.name);
                        if ( index >= 0 ) {
                            const itemId = `C${index}-${categ.name}`;
                            const items = [itemId];
                            // console.log('Selected categ items: ' + JSON.stringify(items));
                            categItemsChange(null, items);
                        }
                    });
                }).catch(error => console.log('Failed to add category: ' + error));
        }
    }
    
    const handleDeleteAction = () => {
        if ( Array.isArray(selectedItems) && selectedItems.length > 0 ) {
            const id = selectedItems[0];
            const i = id.indexOf('-');
            if (i >= 0 && i < id.length - 1) {
                const cat = id.substring(i + 1);
                // console.log('cat=' + cat);
                const index = categories.findIndex( c => c.name === cat);
                if ( index >= 0 ) {
                    const categ = categories[index];
                    if ( categ ) {
                        setDeleteCategory(categ);
                        setDeleteIndex(index);
                        setDeleteCategoryDialogOpen(true);
                    }
                }
            }
        }
    };

    const handleCategoryDeleteSave = (entry) => {
        setDeleteCategoryDialogOpen(false);
        if ( entry?.categ?.id ) {
            console.log('Deleting category: ' + entry.categ.id);
            netDelete(`/api/catalog/categ/${entry.categ.id}`).then(response => {
            if (!response.ok) {
                console.log('Could not delete category: error = ' + response.status);
            } else {
                loadCategories(() => {
                    setDeleteCategEnabled(false);
                    setSelectedItems([]);
                    dispatch(setMediaCategories([]));
                });
            }
        });
        }
    };

    return (
        <Box sx={{height: 'calc(100% - 54px)', display: 'grid', gridTemplateRows: 'auto 1fr auto'}}>
            <Box sx={{borderBottom: `1px solid ${theme.palette.grey[100]}`}}>
                <Typography sx={{fontSize: 18, fontWeight: theme.typography.fontWeightBold, padding: 2, pt: 3}}>Categories</Typography>
            </Box>
            <Box sx={{ position: 'relative', overflow: 'auto' }}>
                <SimpleTreeView multiSelect selectedItems={selectedItems} onSelectedItemsChange={categItemsChange}>
                     <TreeItem itemId={'C00-ALL'} label={'ALL'} sx={{fontStyle: 'italic'}} />
                    {Array.isArray(categories) && categories.map((categ, index) =>
                        <TreeItem itemId={`C${index}-${categ.name}`} label={categ.name} />
                    )}
                </SimpleTreeView>
            </Box>
            <Box sx={{ padding: '1ex', whiteSpace: 'nowrap', overflowX: 'hidden', borderTop: `1px solid ${theme.palette.grey[100]}` }} color={theme.palette.primary.main}>
                <Tooltip title="Add Category">
                    <IconButton color="inherit"  onClick={handleAddAction} sx={{ marginLeft: '2px', marginRight: '6px' }} disabled={readOnly}>
                        <AddIcon color="inherit" />
                    </IconButton>
                </Tooltip>

                <Tooltip title="Delete Category">
                    <IconButton color="inherit" disabled={!deleteCategEnabled || readOnly} onClick={handleDeleteAction} sx={{ marginLeft: '6px', marginRight: '6px' }}>
                        <DeleteIcon color="inherit" />
                    </IconButton>
                </Tooltip>

            </Box>
            <AddCategoryDialog open={addCategoryDialogOpen} onCancel={() => setAddCategoryDialogOpen(false)} 
                onSave={handleCategoryAddSave} />
            <DeleteCategoryDialog open={deleteCategoryDialogOpen} onCancel={() => setDeleteCategoryDialogOpen(false)}
                categ={deleteCategory} index={deleteIndex}
                onSave={handleCategoryDeleteSave} />
        </Box>
    );
}

const MediaCatalogModule = {
    // label
    name: 'media',
    label: 'Media Catalog',
    barLabel: 'Media Catalog',
    barShortLabel: 'Media',
    // icon
    icon: <PermMediaIcon fontSize="inherit" />,
    // menu
    drawerContent: <CategoryList />,
    // initial body page
    pageContent: null,
    cardContent: {
        page: <ImagePanel />,
        name: 'graphics',
        reuse: false,
        right: true,
        icon: <PermMediaIcon fontSize="inherit" />,
        includeModules: ['workflow', 'dlib'],
        enableRightCloseButton: true,
        label: 'Media List',
        origin: 'media',
    },
    setCard: card => {
        postal.publish(
            "app.page.card.change",
            card,
        );
    },
    // send new body page on menu actions
    pageChange: (page) => {},
    drawerChange: (drawer) => {},
    drawerOpen: (open) => {},
    menuIconChange: (icon) => {},
    onMenuIconClick: (event) => {},
    drawerWidth: 260,

    hooks: {}, // { workflow: workflowInfo },
    route: {
        path: "media",
        element: <CategoryList />,
    },
    aclPaths: [ 
        {path: '/C/catalog', label: 'Media Catalog'}, 
    ],
}

export { MediaFileChooser, MediaCatalogModule, ImageViewer };